export const BASKET_ERROR = {
  getPickupTimesSaga:
    "We couldn't load the available pickup and delivery times. Refresh the page and try again.",
  setPickupTimeSaga: "We couldn't set the time you chose. Please try again.",
  // Distinct from setPickupTimeSaga: this is the ORDER_TIME_UNAVAILABLE state
  // (orderStatus/saga.ts, "prep time is outside menu hours"), where retrying the
  // same time always fails — the diner has to pick a different one.
  //
  // Renders in the checkout status bar (type: WARNING, so StatusBar does not
  // suppress it). The PickupTimeErrorHandler modal opens on the same status but
  // renders its OWN hardcoded copy ("too large for us to prepare before we
  // close") and only reads orderStatus.message to compute initErrorType — so this
  // string and that modal's text are on screen together. They must not give the
  // diner two different causes for one failure, so this states the same cause the
  // trigger actually detects and leaves the next step to the modal's "Update
  // Time" / edit-order buttons. Both are mounted inside the same
  // `<Render condition={hasItems}>` block in pages/checkout.tsx, and StatusBar is
  // the only diner-facing surface that prints this message, so the modal is
  // always co-rendered with it.
  //
  // Do not reword this to contain "please choose another time": that is an
  // INITIALIZATION_ERRORS key (constants/basket.ts) and getInitializationErrorType
  // substring-matches it, which would reclassify the status as THROTTLING.
  orderTimeUnavailable: "We can't prepare your order before this location closes.",
  addItemErrorToastSaga: "We couldn't add that item to your basket. Please try again.",
};

export const BASKET_MESSAGE = {
  addItemToastSaga: 'An item was added to your basket',
  addItemsToastSaga: 'items were added to your basket',
  updateItemToastSaga: 'An item was updated in your basket',
  updateItemsToastSaga: 'items were updated in your basket',
};
